
import { useRef, useState } from 'react';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { Dropdown } from 'primereact/dropdown';
import { useGlobalContext } from "../Config";
import { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';



const FormSubirPlantilla = ({
    isFormVisible,
    setIsFormVisible,
    fetchDocumentos,
    toast,
}) => {
    const [totalSize, setTotalSize] = useState(0);
    const fileUploadRef = useRef(null);
    const [empresa, setEmpresa] = useState(null);
    const [listaEmpresas, setListaEmpresas] = useState([]);
    const { baseUrl, urlContratos } = useGlobalContext();
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tipoSeleccionado, setTipoSeleccionado] = useState(null);
    const [tiposDocumentoOptions, setTiposDocumentoOptions] = useState([]);

    const onTemplateSelect = (e) => {
        const file = e.files?.[0];
        if (!file) return;

        const isDocx =
            file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            /\.docx$/i.test(file.name);

        if (!isDocx) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Archivo no permitido',
                detail: 'Solo se aceptan documentos .docx',
                life: 3000
            });
            fileUploadRef.current?.clear();
            setTotalSize(0);
            setSelectedFile(null);
            return;
        }

        setTotalSize(file.size || 0);
        setSelectedFile(file);
    };

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
        setSelectedFile(null);
    };

    const headerTemplate = (options) => {
        const { className, chooseButton /* , uploadButton, cancelButton */ } = options;
        const value = totalSize / 10000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {/* uploadButton y cancelButton eliminados */}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / 1 MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }} />
                </div>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '40%' }}>
                    <i className="pi pi-file mr-2" style={{ fontSize: '1.5rem' }} />
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                <Button
                    type="button"
                    icon="pi pi-times"
                    className="p-button-outlined p-button-rounded p-button-danger ml-auto"
                    onClick={() => onTemplateRemove(file, props.onRemove)}
                />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-file-word mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Arrastra y suelta el Word aquí
                </span>
            </div>
        );
    };

    useEffect(() => {
        if (isFormVisible) {
            obtenerEmpresas();
        }
    }, [isFormVisible, baseUrl]);

    const obtenerEmpresas = async () => {
        try {
        const response = await fetch(`${baseUrl}/getAllEmpresas`);
        const data = await response.json();
        setListaEmpresas(data.empresas); 
        } catch (error) {
        console.error("Error al obtener las empresas:", error);
        }
    };

    const obtenerTiposDocumentoByEmpresa = async (empresaSel) => {
        try {
            const empresaParam = empresaSel?.id ?? empresaSel?.nombre ?? empresaSel;
            const response = await fetch(
                `${urlContratos}getTiposDocumentoByEmpresa?empresa=${encodeURIComponent(empresaParam)}`,
                {
                    method: 'GET',
                    credentials: 'include',
                }
            );
            const data = await response.json();
            const lista = Array.isArray(data.tiposDocumentos) ? data.tiposDocumentos : Object.values(data.tiposDocumentos || {});
            setTiposDocumentoOptions(lista);
        } catch (error) {
            console.error("Error al obtener los tipos de documento:", error);
        }
    };

    useEffect(() => {
        if (empresa) {
            obtenerTiposDocumentoByEmpresa(empresa.nombre);
        } else {
            setTiposDocumentoOptions([]);
            setTipoSeleccionado(null);
        }
    }, [empresa]);

    const chooseOptions = { icon: 'pi pi-fw pi-file-word', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };

    // Botón Guardar: envía la plantilla al backend
    const handleGuardar = async () => {
        try {
            setLoading(true);  
            if (!empresa) {
                toast.current?.show({ severity: 'warn', summary: 'Empresa requerida', detail: 'Seleccione una empresa', life: 3000 });
                return;
            }
            if (!selectedFile) {
                toast.current?.show({ severity: 'warn', summary: 'Archivo requerido', detail: 'Seleccione un archivo .docx', life: 3000 });
                return;
            }

            const formData = new FormData();
            formData.append('empresa', empresa?.nombre);
            formData.append('nombre', selectedFile.name);
            formData.append('idUsuarioStr', sessionStorage.getItem('usuario_id') || '');
            formData.append('idTipoDocumentoStr', tipoSeleccionado.id);
            formData.append('file', selectedFile);

            const response = await fetch(`${urlContratos}guardarPlantilla`, {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });

            if (!response.ok) {
                throw new Error(`Error al subir plantilla (${response.status})`);
            }

            fileUploadRef.current?.clear();

            await fetchDocumentos();
            toast.current?.show({ severity: 'success', summary: 'Éxito', detail: 'Plantilla guardada', life: 3000 });
        } catch (err) {
            console.error(err);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar la plantilla ' + err.message, life: 4000 });
        } finally {
            
            setSelectedFile(null);
            setTotalSize(0);
            resetFormPlantilla();
            setIsFormVisible(false);
            setLoading(false); 
        }
    };

    const resetFormPlantilla = () => {
        setEmpresa(null);
        setSelectedFile(null);
        setTotalSize(0);
    };

    const handleDialogHide = () => {
        resetFormPlantilla();
        setIsFormVisible(false);
    };

    return (
        <Dialog
            visible={isFormVisible}
            onHide={handleDialogHide}
            className="p-fluid product-dialog"
            closable={true}
            modal
            footer={
                <>
                <div className="flex justify-content-end mt-3">
                    <Button
                        label="Guardar"
                        icon={loading ? "pi pi-spin pi-spinner" : "pi pi-save"}
                        className="p-button-success p-button-rounded p-button"
                        raised
                        onClick={handleGuardar}
                        disabled={!empresa || !selectedFile || loading}
                    />
                </div>
                </>
            }
            header={"Crear Plantilla"}
        >
        
            <div className="card">
                <h6 className="mb-3">
                    Sube la plantilla que se usará para generar documentos de este tipo.
                </h6>

                <span>
                    Descargar Plantilla de Ejemplo
                </span>

                <span className="p-float-label mt-2 mb-3">
                    <Dropdown
                        id="empresa"
                        value={empresa}
                        onChange={(e) => {
                            setEmpresa(e.value);
                            setTipoSeleccionado(null);
                            setTiposDocumentoOptions([]);
                        }}
                        options={listaEmpresas}
                        optionLabel="nombre"
                        placeholder="Seleccione Empresa"
                        style={{ borderRadius: "4px" }}
                        icon="pi pi-building"
                        className="w-full p-inputtext-lg"
                        required
                        disabled={loading}
                    />
                    <label htmlFor="empresa">Empresa </label>
                </span>

                <span className="p-float-label w-full mb-3">
                    <Dropdown
                        id="tipoDocumento"
                        value={tipoSeleccionado}
                        onChange={(e) => setTipoSeleccionado(e.value)}
                        options={tiposDocumentoOptions}
                        optionLabel="descripcion"
                        placeholder="Seleccione Tipo"
                        className="w-full p-inputtext-lg"
                        required
                        disabled={!empresa || tiposDocumentoOptions.length === 0 || loading}
                        
                    />
                    <label htmlFor="tipoDocumento">Tipo de Documento</label>
                </span>

                <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
                <span className="p-float-label mt-2 mb-3">
                    <h6>Seleccione Plantilla</h6>
                </span>
                <FileUpload
                    ref={fileUploadRef}
                    name="documento"
                    url="/api/upload"
                    multiple={false}
                    accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    maxFileSize={1000000}
                    onSelect={onTemplateSelect}
                    onError={onTemplateClear}
                    onClear={onTemplateClear}
                    headerTemplate={headerTemplate}
                    itemTemplate={itemTemplate}
                    emptyTemplate={emptyTemplate}
                    chooseOptions={chooseOptions}
                />

            
            </div>
            
        </Dialog>
    );
}
export default FormSubirPlantilla;